module.exports = __webpack_public_path__ + "img/logo.180e7310.png";